import { useState } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';

import { themeColors, brandColors } from 'colors';
import { Campaign } from 'domains/campaigns/types';

import ABTestInsightsModal from './AbTestInsightsModal/ABTestInsightsModal';

type PendingWinnerSelectionStatusProps = {
    campaign: Campaign;
};

const PendingWinnerSelectionStatus = ({ campaign }: PendingWinnerSelectionStatusProps) => {
    const [isInsightsModalOpen, setIsInsightsModalOpen] = useState(false);

    const handleViewInsights = () => {
        setIsInsightsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsInsightsModalOpen(false);
    };

    // Only show send winner button for 50% split (when there's remaining audience)
    const shouldShowSendWinnerButton = campaign.abTestConfig?.testPercentage === 50;

    return (
        <>
            <ABTestInsightsModal campaign={campaign} isOpen={isInsightsModalOpen} handleModalClose={handleModalClose} />
            <Box
                sx={{
                    backgroundColor: brandColors.garlic,
                    borderRadius: '8px',
                    padding: '16px',
                }}
            >
                <Stack spacing={1}>
                    <Stack spacing={0.5}>
                        <Stack direction="row" alignItems="baseline" spacing={1.4}>
                            <Box
                                sx={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: themeColors.other.ratingActive,
                                }}
                            />
                            <Typography>pending winner selection</Typography>
                        </Stack>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Test ended. You can now view the insights for both of the emails.
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} justifyContent={'end'} sx={{ paddingLeft: '20px' }}>
                        <Button
                            variant="outlined"
                            onClick={handleViewInsights}
                            sx={{
                                backgroundColor: 'white',
                            }}
                        >
                            View Insights
                        </Button>
                        {shouldShowSendWinnerButton && (
                            <Button variant="contained" disabled={true}>
                                Send winner
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default PendingWinnerSelectionStatus;
